<template src="./Organizations.html"></template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "organizations",
  data() {
    return {
      showModal: false,
      dropDownMerchants: "მაღაზიები",
      dropDownCashierLoyalty: "ლოალობის პირობები",
      dropDownPoseName: "სალაროები",

      dropDownMCashierLoyaltyFormMerchantValue: "მაღაზიები",
      dropDownMCashierLoyaltyFormLoyaltyValue: "ლოიალობის პირობები",

      merchant: {
        id: "",
        name: "",
        districtId: null,
        legalId: null,
        legalBrandId: null,
        legalBrandName: null,
        status: null,
        address: "",
        email: "",
        phone: "",
      },
      merchantCashierLoyalty: {
        id: "",
        merchantId: "",
        code: "",
        cashierLoyaltyId: "",
        isActive: false,
      },
      poseRange: {
        id: null,
        startPoint: "",
        endPoint: "",
      },
      organizations: {
        id: "",
        identificationCode: "",
        name: "",
        password: "",
        physicalAddress: "",
        legalAddress: "",
        mobile: "",
        email: "",
        dirFirstName: "",
        dirLastName: "",
        hasMerchant: false,
        merchantCout: 0,
        hasLoyalty: false,
      },
      legalBrand: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        logoSrc: null,
        lBCategoryId: null,
        merchants: [],
      },
      lastID: 14,
      merchantID: 0,
      posesID: 0,
      isActive: false,
      arrayPoseRange: [],
      arrayMerchant: [],
      array: [],
      LegalsArray: [],
      LegalBrandsArray: [],
      dropDownLegal: "აირჩიეთ ორგანიზაცია",
      dropDownLegalBrand: "აირჩიეთ ლეგალ ბრენდი",
      isEditMerchant: false,
      arrayCashierLoyalties: [],
      arrayMerchantCashierLoyalties: [],
      isMerchantCashierLoyaltyEdit: false,
      filteredDataArray: [],
      searchText: null,
    };
  },
  validations: {
    merchant: {
      name: {
        required,
      },
      districtId: {
        required,
      },
      legalBrandId: {
        required,
      },
      address: {
        required,
      },
      email: {
        required,
      },
      phone: {
        required,
      },
      legalBrandId: {
        required,
      },
      status: {
        required,
      },
    },
    poses: {
      merchantID: {
        required,
      },
      posCode: {
        required,
      },
    },
    merchantCashierLoyalty: {
      merchantId: {
        required,
      },
      code: {
        required,
      },
      cashierLoyaltyId: {
        required,
      },
      isActive: {
        required,
      },
    },
    organizations: {
      identificationCode: {
        required,
      },
      name: {
        required,
      },
      physicalAddress: {
        required,
      },
      legalAddress: {
        required,
      },
      mobile: {
        required,
      },
      email: {
        required,
        email,
      },
      dirFirstName: {
        required,
      },
      dirLastName: {
        required,
      },
    },
  },
  async created() {
    let organizationResult = await this.$http.getLegal();
    this.array = organizationResult.data.res;
    this.filteredDataArray = this.array;

    let legalResult = await this.$http.getLegal();
    this.LegalsArray = legalResult.data.res;

    let leglaBrandResult = await this.$http.getLegalBrand();
    this.LegalBrandsArray = leglaBrandResult.data.res;

    let cashierLoyaltiesResult = await this.$http.getCashierLoyalties();
    this.arrayCashierLoyalties = cashierLoyaltiesResult.data.res;
  },
  methods: {
    async addOrganization() {
      try {
        let organizationObjectAdd = {
          identificationCode: this.organizations.identificationCode,
          name: this.organizations.name,
          password: this.organizations.password,
          physicalAddress: this.organizations.physicalAddress,
          legalAddress: this.organizations.legalAddress,
          mobile: this.organizations.mobile,
          email: this.organizations.email,
          dirFirstName: this.organizations.dirFirstName,
          dirLastName: this.organizations.dirLastName,
          hasMerchant: this.organizations.hasMerchant,
          merchantCout: 0,
          hasLoyalty: false,
          merchants: this.arrayMerchant,
        };

        let organizationAddResult = await this.$http.postLegal(
          organizationObjectAdd
        );

        if (organizationAddResult.data.resultCode === "200") {
          bus.$emit("success", "ორგანიზაცია წარმატებით დაემატა");
          let organizationResult = await this.$http.getLegal();
          this.array = organizationResult.data.res;
        } else {
          bus.$emit("warning", "ორგანიზაცია დამატების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async addMerchant() {
      let _merch = {
        id: this.merchant.id,
        address: this.merchant.address,
        districtId: this.merchant.districtId,
        email: this.merchant.email,
        legalBrandId: this.merchant.legalBrandId,
        legalId: this.organizations.id,
        name: this.merchant.name,
        phone: this.merchant.phone,
        status: this.merchant.status,
      };

      //Legal brand name
      let index = this.LegalBrandsArray.findIndex(
        (d) => d.id === this.merchant.legalBrandId
      );
      _merch.legalBrandName = this.LegalBrandsArray[index].nameGe;

      if (this.isEditMerchant) {
        try {
          let editMerchantResult = await this.$http.putMerchant(_merch);

          if (editMerchantResult.data.resultCode === "200") {
            bus.$emit("success", "მერჩანტი წარმატებით შიცვალა");
            this.merchantID++;
            this.arrayMerchant.push(_merch);

            (this.merchant.address = ""),
              (this.merchant.districtId = null),
              (this.merchant.email = ""),
              (this.merchant.legalBrandId = null),
              (this.dropDownLegalBrand = "აირჩიეთ ლეგალ ბრენდი"),
              (this.merchant.legalId = ""),
              (this.merchant.name = ""),
              (this.merchant.phone = ""),
              (this.merchant.status = false);
            this.isEditMerchant = false;
          } else {
            bus.$emit("warning", "მერჩანტის ცვლილებისას მოხდა შეცდომა");
          }
        } catch (error) {
          bus.$emit("error", error);
        }
      } else {
        try {
          let addMerchantResult = await this.$http.postMerchant(_merch);

          if (addMerchantResult.data.resultCode.status === "200") {
            bus.$emit("success", "მერჩანტი წარმატებით დაემატა");
            _merch.id = addMerchantResult.data.resultCode.id;
            this.merchantID++;
            this.arrayMerchant.push(_merch);

            (this.merchant.address = ""),
              (this.merchant.districtId = null),
              (this.merchant.email = ""),
              (this.merchant.legalBrandId = null),
              (this.dropDownLegalBrand = "აირჩიეთ ლეგალ ბრენდი"),
              (this.merchant.legalId = ""),
              (this.merchant.name = ""),
              (this.merchant.phone = ""),
              (this.merchant.status = false);
            this.isEditMerchant = false;
          } else {
            bus.$emit("warning", "მერჩანტის დამატებისას მოხდა შეცდომა");
          }
        } catch (error) {
          bus.$emit("error", error);
        }
      }

      this.isEditMerchant = false;
      this.$v.$reset();
    },
    addMerchantLocal() {
      this.merchantID++;

      let _merch = {
        address: this.merchant.address,
        districtId: this.merchant.districtId,
        email: this.merchant.email,
        legalBrandId: this.merchant.legalBrandId,
        legalId: this.organizations.id,
        name: this.merchant.name,
        phone: this.merchant.phone,
        status: this.merchant.status,
        isNew: true,
        id: this.merchantID,
      };

      //Legal brand name
      let index = this.LegalBrandsArray.findIndex(
        (d) => d.id === this.merchant.legalBrandId
      );
      _merch.legalBrandName = this.LegalBrandsArray[index].nameGe;

      this.arrayMerchant.push(_merch);

      (this.merchant.address = ""),
        (this.merchant.districtId = null),
        (this.merchant.email = ""),
        (this.merchant.legalBrandId = null),
        (this.dropDownLegalBrand = "აირჩიეთ ლეგალ ბრენდი"),
        (this.merchant.legalId = ""),
        (this.merchant.name = ""),
        (this.merchant.phone = ""),
        (this.merchant.status = false);
    },
    async addOrEditMerchantCashierLoyalty() {
      if (this.isMerchantCashierLoyaltyEdit) {
        try {
          let editMerchantCashierLoyaltyResult =
            await this.$http.putMerchantCashierLoyalty(
              this.merchantCashierLoyalty
            );

          if (editMerchantCashierLoyaltyResult.data.resultCode === "200") {
            bus.$emit("success", "ოპერაცია დასრულდა წარმატებით");
          } else {
            bus.$emit("warning", "დაფიქსირდა შეცდომა");
          }
        } catch (error) {
          bus.$emit("error", error);
        }
      } else {
        try {
          let addMerchantCashierLoyaltyResult =
            await this.$http.postMerchantCashierLoyalty(
              this.merchantCashierLoyalty
            );

          if (addMerchantCashierLoyaltyResult.data.resultCode === "200") {
            bus.$emit("success", "ოპერაცია დასრულდა წარმატებით");
          } else {
            bus.$emit("warning", "დაფიქსირდა შეცდომა");
          }
        } catch (error) {
          bus.$emit("error", error);
        }
      }

      let merchantCashierLoyaltiesResult =
        await this.$http.getMerchantCashierLoyaltiesByMerchantId(
          this.merchantCashierLoyalty.merchantId
        );
      this.arrayMerchantCashierLoyalties =
        merchantCashierLoyaltiesResult.data.res;

      this.merchantCashierLoyalty.code = "";
      this.dropDownMCashierLoyaltyFormLoyaltyValue = "ლოიალობის პირობები";
      this.merchantCashierLoyalty.cashierLoyaltyId = "";
      this.merchantCashierLoyalty.isActive = false;

      this.isMerchantCashierLoyaltyEdit = false;
    },
    async addOrEditMerchantCashierLoyaltyLocal() {
      let index = this.arrayMerchant.findIndex(
        (d) => d.id === this.merchantCashierLoyalty.merchantId
      );

      if (this.arrayMerchant[index].merchantCashierLoyalties == undefined) {
        this.arrayMerchant[index].merchantCashierLoyalties = [
          Object.assign({}, this.merchantCashierLoyalty),
        ];
      } else {
        this.arrayMerchant[index].merchantCashierLoyalties.push(
          Object.assign({}, this.merchantCashierLoyalty)
        );
      }

      this.arrayMerchantCashierLoyalties =
        this.arrayMerchant[index].merchantCashierLoyalties;

      console.log(this.arrayMerchantCashierLoyalties);

      this.merchantCashierLoyalty.code = "";
      this.dropDownMCashierLoyaltyFormLoyaltyValue = "ლოიალობის პირობები";
      this.merchantCashierLoyalty.cashierLoyaltyId = "";
      this.merchantCashierLoyalty.isActive = false;

      //this.isMerchantCashierLoyaltyEdit = false;
    },
    dropDownMCashierLoyaltyFormMerchantLocal(merchantName, id) {
      this.dropDownMCashierLoyaltyFormMerchantValue = merchantName;
      this.merchantCashierLoyalty.merchantId = id;

      let index = this.arrayMerchant.findIndex((d) => d.id === id);

      this.arrayMerchantCashierLoyalties =
        this.arrayMerchant[index].merchantCashierLoyalties;
    },
    async dropDownMCashierLoyaltyFormMerchantClick(merchantName, id) {
      let merchantCashierLoyaltiesResult =
        await this.$http.getMerchantCashierLoyaltiesByMerchantId(id);
      this.arrayMerchantCashierLoyalties =
        merchantCashierLoyaltiesResult.data.res;

      this.dropDownMCashierLoyaltyFormMerchantValue = merchantName;
      this.merchantCashierLoyalty.merchantId = id;
    },
    dropDownMCashierLoyaltyFormLoyaltyClick(name, id) {
      this.dropDownMCashierLoyaltyFormLoyaltyValue = name;
      this.merchantCashierLoyalty.cashierLoyaltyId = id;

      this.merchantCashierLoyalty.cashierLoyalty = { id: id, name: name };
    },
    async editOrganization() {
      try {
        let organizationEditResult = await this.$http.putLegal(
          this.organizations
        );

        if (organizationEditResult.data.resultCode === "200") {
          bus.$emit("success", "ორგანიზაცია წარმატებით დარედაქტირდა");
          let organizationResult = await this.$http.getLegal();
          this.array = organizationResult.data.res;
        } else {
          bus.$emit("warning", "ორგანიზაცია რედაქტირების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteOrganization() {
      try {
        let organizationDeleteResult = await this.$http.deleteLegal(
          this.organizations.id
        );

        if (organizationDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "ორგანიზაცია წარმატებით წაიშალა");
          let organizationResult = await this.$http.getLegal();
          this.array = organizationResult.data.res;
        } else {
          bus.$emit("warning", "ორგანიზაცია წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    //edit org
    async editFillInputs(row) {
      let legalResult = await this.$http.getByIDLegal(row.id);
      this.organizations = legalResult.data.res;
      this.arrayMerchant = this.organizations.merchants;
      this.arrayMerchant.forEach((element) => {
        let index = this.LegalBrandsArray.findIndex(
          (d) => d.id === element.legalBrandId
        );
        element.legalBrandName = this.LegalBrandsArray[index].nameGe;
      });

      //Clear dirty validation cash
      this.$v.$reset();
    },
    async editMerchantFillInputs(row) {
      this.merchant = Object.assign({}, row);
      let deleteIndex = this.arrayMerchant.findIndex((d) => d.id === row.id);
      this.arrayMerchant.splice(deleteIndex, 1);

      this.isEditMerchant = true;
      this.dropDownLegalBrand = this.merchant.legalBrandName;
    },
    editMerchantCashierLoyalty(row) {
      this.merchantCashierLoyalty = Object.assign({}, row);

      let deleteIndex = this.arrayMerchantCashierLoyalties.findIndex(
        (d) => d.id === row.id
      );
      this.arrayMerchantCashierLoyalties.splice(deleteIndex, 1);

      this.dropDownMCashierLoyaltyFormLoyaltyValue = row.cashierLoyalty.name;
      this.isMerchantCashierLoyaltyEdit = true;
    },
    getDeleteId(id) {
      this.organizations.id = id;
    },
    async getMerchantDeleteId(id) {
      try {
        let deleteMerchantResult = await this.$http.deleteMerchant(id);

        if (deleteMerchantResult.data.resultCode === "200") {
          bus.$emit("success", "მერჩანტი წარმატებით წაიშალა");
          /*let organizationResult = await this.$http.getLegal();
          this.array = organizationResult.data.res;
          */
          let deleteIndex = this.arrayMerchant.findIndex((d) => d.id === id);
          this.arrayMerchant.splice(deleteIndex, 1);
        } else {
          bus.$emit("warning", "მერჩანტის წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("warning", "მერჩანტის წაშლის დროს მოხდა შეცდომა!"); //"error" not working
      }
    },
    getMerchantDeleteIdLocal(id) {
      let deleteIndex = this.arrayMerchant.findIndex((d) => d.id === id);
      this.arrayMerchant.splice(deleteIndex, 1);
    },
    getPoseDeleteId(id) {
      let deleteIndex = this.arrayPoses.findIndex((d) => d.id === id);
      this.arrayPoses.splice(deleteIndex, 1);
    },
    modalPrepare() {
      this.isActive = true;
    },

    dropDownLegalBrandClick(legalBrandName, legalBrandId) {
      this.dropDownLegalBrand = legalBrandName;
      this.legalBrand.nameGe = legalBrandName;
      this.legalBrand.id = legalBrandId;
      this.merchant.legalBrandId = legalBrandId;
      this.merchant.legalBrandName = legalBrandName;
    },
    searchData() {
      this.filteredDataArray = this.array.filter(
        (item) =>
          item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
      );
    },
    clearData() {
      this.organizations.id = null;
      this.organizations.identificationCode = "";
      this.organizations.name = "";
      this.organizations.password = "";
      this.organizations.physicalAddress = "";
      this.organizations.legalAddress = "";
      this.organizations.mobile = "";
      this.organizations.email = "";
      this.organizations.dirFirstName = "";
      this.organizations.dirLastName = "";
      this.organizations.hasMerchant = false;
      this.merchant.id = null;
      this.merchant.personalID = "";
      this.merchant.legalId = "";
      this.merchant.name = "";
      this.merchant.address = "";
      this.merchant.merchantLoyalty = "";

      this.merchant.address = "";
      this.merchant.districtId = null;
      this.merchant.email = "";
      this.merchant.legalBrandId = null;
      this.merchant.legalBrandName = null;
      this.dropDownLegalBrand = "აირჩიეთ ლეგალ ბრენდი";
      this.merchant.legalId = "";
      this.merchant.name = "";
      this.merchant.phone = "";
      this.merchant.status = false;

      this.dropDownMCashierLoyaltyFormMerchantValue = "მაღაზიები";
      this.dropDownMCashierLoyaltyFormLoyaltyValue = "ლოიალობის პირობები";
      this.merchantCashierLoyalty.id = "";
      this.merchantCashierLoyalty.merchantId = "";
      this.merchantCashierLoyalty.code = "";
      this.merchantCashierLoyalty.cashierLoyaltyId = "";
      this.merchantCashierLoyalty.isActive = false;

      this.arrayMerchant = [];
      this.arrayMerchantCashierLoyalties = [];
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/Organizations.vue